export interface ImageProps {
  src?: any;
  alt: string;
  cover?: boolean;
  width?: string;
  onLoad?: () => void;
}

export const Image = ({
  src,
  alt,
  cover = false,
  width,
  onLoad,
}: ImageProps) => {
  if (typeof src === 'string') {
    return (
      <img
        src={src}
        alt={alt}
        style={{ objectFit: cover ? 'cover' : 'contain', width }}
        onLoad={onLoad}
      />
    );
  }

  return <img src={src.src} alt={alt} onLoad={onLoad} />;
};
